import msg from '../getErrorMsg';
import defaults from 'DEFAULTS';
import { Strings } from 'HELPERS';

export default (input, params, context) => {
  const precision = input.precision || 2;
  const regex = input.realPercent ? input.percentValidateRegex : defaults.re.percents;

  if (!regex.test(input.value)) {
    return Strings.Compile(msg(context, 'notPercentages'), { precision });
  }

  return false;
};
